'use client'
import { ButtonLink, LogoTypeBrand } from '@repo/shared/components'
import { useTranslate, type MessagesKeys } from '@repo/shared/hooks'
import { Link } from '@repo/shared/i18n/navigation'
import { Row, Skeleton } from '@repo/ui/components'
import { cn } from '@repo/ui/lib/utils'
import dynamic from 'next/dynamic'
import { DashboardAccountHeaderLayout } from './dashboard-account.header.layout'
import { FeatureFlag } from '@repo/shared/components'
import { useEffect } from 'react'
import { useFeatureFlags } from '@repo/services'
import { globalConfig, useFeatureFlagsStore } from '@repo/shared'

const ThemeButton = dynamic(
  () => import('@repo/shared/components').then((mod) => mod.ThemeButton),
  {
    ssr: false,
    loading: () => <Skeleton className='w-[28px] h-[32px]' />,
  },
)

type NavItem = {
  label: MessagesKeys
  href: string
  disabled: boolean
  flagKey: string
  target?: string
}

export const DashboardHeaderLayout = () => {
  const { t } = useTranslate()

  const navItems: NavItem[] = [
    {
      label: 'profileLayout_buyAndSell',
      href: '/quick-trade',
      disabled: false,
      flagKey: 'quick-trade',
    },
    {
      label: 'profileLayout_projects',
      href: '/rwa',
      disabled: false,
      flagKey: 'allow',
    },
    {
      label: 'profileLayout_secondaryMarket',
      href: '/advanced-trade',
      disabled: false,
      flagKey: 'advanced-trade',
    },
    {
      label: 'profileLayout_club',
      href: '/club/invite',
      disabled: false,
      flagKey: 'allow',
    },
    // {
    //   label: 'menu_blog',
    //   href: `${globalConfig.baseUrl}/blog`,
    //   disabled: false,
    //   flagKey: 'allow',
    //   target: '_blank',
    // },
  ]

  const featureFlagsQuery = useFeatureFlags({
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    staleTime: Infinity,
  })
  const { setFlags } = useFeatureFlagsStore()

  useEffect(() => {
    if (featureFlagsQuery?.data?.flags) {
      setFlags(featureFlagsQuery?.data?.flags)
    }
  }, [featureFlagsQuery?.data?.flags])

  return (
    <div className={cn('sticky top-0 w-full z-10', 'bg-neutral-surface-light')}>
      <div className='w-full p-2 flex h-16 items-center justify-between'>
        <div className='flex items-center gap-4'>
          <Row
            as={Link}
            href='/dashboard'
            className='relative w-[5.25rem] aspect-[3/1]'
          >
            <LogoTypeBrand
              alt='logo'
              fill
              className='object-contain'
              sizes='(max-width: 768px) 100vw, 5.25rem'
              priority
            />
          </Row>
          <div className='flex items-center gap-2'>
            {navItems.map((item, index) => (
              <FeatureFlag key={index} flagKey={item.flagKey}>
                <ButtonLink
                  variant='transparent'
                  color='neutral'
                  size='sm'
                  href={`${item.href}`}
                  target={item.target}
                  className={cn(
                    item.disabled
                      ? 'opacity-50 cursor-not-allowed pointer-events-none'
                      : '',
                  )}
                >
                  {t(item.label)}
                </ButtonLink>
              </FeatureFlag>
            ))}
          </div>
        </div>
        <div className='flex items-center gap-4'>
          <DashboardAccountHeaderLayout />
          <ThemeButton />
        </div>
      </div>
    </div>
  )
}
